module.exports = __webpack_public_path__ + "img/industry-list-3.c421638c.jpg";